export enum AppRoute {
  MAIN_PAGE_ROUTE = '/',
  CHECKOUT_PAGE_ROUTE = '/checkout',
  PAYMENT_PAGE_ROUTE = '/payment',
  PAYMENT_RESULT_PAGE_ROUTE = '/payment-result',
}
